import { CoEditionRequestStatus, ProductAccessibilityEnum, PublisherRegistrationAgencyEnum, PublisherStatusEnum, } from "../types/Api";
// Default selections of the either/or/both checkbox groups. A group is never empty (see
// utils/requiredSelection.ts); opening a list without URL params and "Zrušit vše" both return
// the group to these values. Person status defaults live in personFilterStatuses.ts.
// International prefixes and agency prefixes: search both agencies.
export var DEFAULT_REGISTRATION_AGENCIES = [
    PublisherRegistrationAgencyEnum.ISBN,
    PublisherRegistrationAgencyEnum.ISMN,
];
// Publishers: the most commonly used view shows active publishers only.
export var DEFAULT_PUBLISHER_STATUSES = [
    PublisherStatusEnum.ACTIVE,
];
// Products: both private and public products.
export var DEFAULT_PRODUCT_ACCESSIBILITY = [
    ProductAccessibilityEnum.PRIVATE,
    ProductAccessibilityEnum.PUBLIC,
];
// Co-edition requests: pending requests only (awaiting the co-publisher's consent or the agency).
export var DEFAULT_CO_EDITION_REQUEST_STATUSES = [
    CoEditionRequestStatus.AWAITING_CO_PUBLISHER,
    CoEditionRequestStatus.REQUESTED,
];
